// extracted by mini-css-extract-plugin
export default {"poperPanel":"PopperPanel_poperPanel__tqxLW"};